/** Выбор усиления «1 из 3» — подключение к стору и колбэкам. */
import type { WindowProps } from "../kit";
import { BoostChoiceView } from "./view";
import { appStore, battleStore, setBoostOffer, useStore, registerWindow } from "../../../app";
import { actions } from "../actions";
import { recommendBoost, shouldShowBoostHint } from "./model";
import { useEffect, useState } from "preact/hooks";

/** Флаг «совет в выборе усиления уже видел» — в localStorage; нет хранилища — совет покажется снова. */
export const BOOST_HINT_KEY = "nfg:hint:boost";

function hintSeen(): boolean {
  try {
    return window.localStorage.getItem(BOOST_HINT_KEY) === "1";
  } catch {
    return false;
  }
}

function markHintSeen(): void {
  try {
    window.localStorage.setItem(BOOST_HINT_KEY, "1");
  } catch {
    // без localStorage — покажем ещё раз, не страшно
  }
}

export function BoostChoice({ close }: WindowProps<"boostChoice">) {
  const options = useStore(appStore, (s) => s.boostOffer);
  const bestWave = useStore(appStore, (s) => s.player?.bestWave ?? 0);
  const runWave = useStore(appStore, (s) => s.player?.run.wave ?? null);
  const battleWave = useStore(battleStore, (s) => s?.wave.number ?? null);
  // совет решается один раз на открытие окна: не мигает, если стор обновится
  const [hint] = useState(() =>
    options && shouldShowBoostHint(bestWave, hintSeen()) ? recommendBoost(options) : null,
  );
  // предложения нет (снято боем) — окну нечего показать
  const empty = !options || options.length === 0;
  useEffect(() => {
    if (empty) close();
  }, [empty]);
  if (!options || empty) return null;
  return (
    <BoostChoiceView
      wave={battleWave ?? runWave}
      options={options}
      hint={hint}
      onChoose={(index) => {
        if (hint !== null) markHintSeen();
        actions().chooseBoost(index);
        setBoostOffer(null);
      }}
    />
  );
}

export function register(): void {
  registerWindow("boostChoice", BoostChoice);
}
